<template>
  <div>
    <select-base
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :label="label"
      :label-select="'nome'"
      :carregar="carregarPacoteServico"
      :filtro-adicional="filtroAdicional"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
import api from '@/app-modulo/comercial/pacote-servico/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'PacoteServicoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    label: {
      type: String,
      default: 'Pacote de serviço',
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      value_: {},
      filtros: [
        {
          coluna: 'Nome',
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarPacoteServico(filtros) {
      return api.getPacoteServicosResumidos(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
